import { SvgIconProps } from '@mui/material'
import React from 'react'

export const LoadingIconQCAD: React.FC<SvgIconProps> = (props: SvgIconProps) => {
  return (
    <svg
      width="135"
      height="135"
      viewBox="0 0 135 135"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ animation: 'spin 2s linear infinite' }}
      {...props}
    >
      <path
        className="path-1"
        d="M80.2438 65.0146V72.5513L88.3416 73.6256L79.2063 81.8319L71.3164 73.942L80.2438 65.0146ZM57.1959 81.8319L48.0588 73.6256L56.1584 72.5513V65.0164L65.084 73.942L57.1959 81.8319ZM68.2002 53.6976L74.8704 64.1519L68.2002 70.8221L61.5318 64.1519L68.2002 53.6976ZM98.4004 70.5131L84.6514 68.6882V54.3745L78.0644 60.9616L68.1984 45.5005L58.3374 60.9606L51.7508 54.3727V68.6882L38 70.5131L57.3578 87.9025L66.0195 79.2397V88.5889H70.3809V79.239L79.0444 87.9025L98.4004 70.5131Z"
        fill="#2CB5C7"
      />
      <g>
        <linearGradient id="a11">
          <stop offset="0" stopColor="#26acc1" stopOpacity="0.2"></stop>
          <stop offset="1" stopColor="#26acc1"></stop>
        </linearGradient>
        <circle
          fill="none"
          stroke="url(#a11)"
          strokeWidth="10"
          strokeLinecap="round"
          strokeDasharray="0 44 0 44 0 44 0 44 0 360"
          cx="68"
          cy="68"
          r="45"
          transform-origin="center"
        >
          <animateTransform
            type="rotate"
            attributeName="transform"
            dur="2.6"
            values="360;324;288;252;216;180;144;108;72;36;0"
            repeatCount="indefinite"
          ></animateTransform>
        </circle>
      </g>
    </svg>
  )
}
